import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatestWith, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IChatSettings } from './copilot.service';
import { HttpClient } from '@angular/common/http';
import { FeatureFlagDxpService } from './feature-flag-dxp.service';
import { FeatureNames } from '../../model/FeatureNames';

@Injectable({ providedIn: 'root' })
export class CopilotOnboardingService {
    shouldShowOnboardingModal$ = new BehaviorSubject<boolean>(true);
    modalVisible$ = new BehaviorSubject<boolean>(false);

    constructor(
        private http: HttpClient,
        private featureFlagDxpService: FeatureFlagDxpService,
    ) {}

    ackOnboardingModal(): void {
        this.hideOnboardingModal();
        // make sure we handle logging an error
        this.http.post('/chat/settings', { user_settings: { opted_in: true } }).subscribe({
            next: () => {
                this.shouldShowOnboardingModal$.next(false);
            },
            error: error => {
                console.error('Error updating user settings:', error);
            },
        });
    }

    shouldShowOnboardingModal(): Observable<boolean> {
        return this.http.get<IChatSettings>('/chat/settings').pipe(
            combineLatestWith(this.featureFlagDxpService.getFeatureFlag(FeatureNames.COPILOT_FORCE_ONBOARDING_MODAL)),
            map(([response, featureFlagStatus]) => {
                // if the Force Onboarding Modal feature flag is enabled, return true
                // if empty response from chat settings endpoint, also return true
                return featureFlagStatus.enabled || response?.userSettings?.optedIn == null
                    ? true
                    : !response.userSettings.optedIn;
            }),
        );
    }

    /**
     * True if the feature flag is enabled, and the user has not explicitly opted out.
     */
    shouldAllowCommandAITour(): Observable<boolean | null> {
        return this.http.get<IChatSettings>('/chat/settings').pipe(
            combineLatestWith(this.featureFlagDxpService.getFeatureFlag(FeatureNames.COPILOT)),
            map(([response, copilotFF]) => {
                return copilotFF?.enabled === true && response?.userSettings?.optedIn !== false;
            }),
            catchError(_ => of(false)), // Will give error if user has no access to copilot
        );
    }

    showOnboardingModal(): void {
        this.modalVisible$.next(true);
    }

    hideOnboardingModal(): void {
        this.modalVisible$.next(false);
    }

    getSuggestionKeywordFromUrl(url: string): string {
        // NOTE: Unused after moving link from topbar to sidenav
        if (url.includes('security')) {
            return 'security';
        }
        if (url.includes('appliances')) {
            return 'performance';
        }
        if (url.includes('performance')) {
            return 'performance';
        }
        if (url.includes('orders')) {
            return 'subscription';
        }
        if (url.includes('subscriptions')) {
            return 'subscription';
        }
        return null;
    }
}
